import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=ff33506e&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"
import style0 from "./guide.vue?vue&type=style&index=0&id=ff33506e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff33506e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff33506e')) {
      api.createRecord('ff33506e', component.options)
    } else {
      api.reload('ff33506e', component.options)
    }
    module.hot.accept("./guide.vue?vue&type=template&id=ff33506e&scoped=true&", function () {
      api.rerender('ff33506e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/guide/guide.vue"
export default component.exports